// extracted by mini-css-extract-plugin
export default {"invalidDataError":"Dispatch_invalidDataError__FM0d5","order-heading":"Dispatch_order-heading__X2PfI","dealer-list":"Dispatch_dealer-list__A+GZm"};